<template>
  <div class="csm-basic">
    <div style="margin: 6px; font-size: 20px">
      校区分布
      <el-tooltip class="item" effect="dark" content="计算" placement="top">
        <i
          v-if="false"
          style="float: right; cursor: pointer"
          class="el-icon-refresh"
          @click="adminCreateSysSchoolEffectInfo"
        ></i>
      </el-tooltip>
    </div>

    <div
      style="margin-top: 20px; width: 100%; height: 300px"
      id="myChart"
    ></div>

    <div class="table-style">
      <el-form size="mini" :inline="true">
        <el-form-item label="学校名称">
          <el-input
            placeholder="请输入学校名称"
            v-model="form.educational_institution_name"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="平台账号">
          <el-input
            placeholder="请输入平台账号"
            v-model="form.username"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="校区类型">
          <el-select v-model="form.is_try">
            <el-option label="全部" value=""></el-option>
            <el-option label="体验校区" value="1"></el-option>
            <el-option label="合作校区" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="search" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        ref="ctab"
        size="mini"
        :data="schoolList"
        :header-cell-style="{ background: 'white' }"
      >
        <el-table-column label="序号" width="50" fixed="left">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (page_no - 1) * 20 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          width="150"
          prop="name"
          label="校区名称"
        ></el-table-column>
        <el-table-column width="100" label="校区超管">
          <template slot-scope="scope">
            <el-tooltip
              v-if="scope.row.principalList.length > 0"
              class="item"
              effect="dark"
              :content="scope.row.principalList[0].name"
              placement="top"
            >
              <span v-if="scope.row.principalList.length > 0">{{
                scope.row.principalList[0].realname
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>

        <el-table-column
          label="合作科目"
          width="150"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span
              style="margin-left: 5px"
              v-for="item of scope.row.schoolSubjectAuthArr"
              :key="item.id"
              >{{ item.subjectInfo.name }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="客户端">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.create_client == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="首页装修">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.homepage_set == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="已建老师">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.create_tch == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="已建教务">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.create_jiaowu == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="已建销售">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.create_seller == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="已有意向">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_intended_stu == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="已有试听">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_try_stu == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>
        <el-table-column label="已有正式">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_normal_stu == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有试听班">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_try_class == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有正式班">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_normal_class == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有试听课">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_try_tchplan == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有常规课">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_normal_tchplan == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有收据">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_receipt == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column label="有课消">
          <template slot-scope="scope">
            <span style="color: green" v-if="scope.row.has_stu_tchplan == 1"
              >✔️</span
            >
            <span v-else style="color: red">⊙</span>
          </template>
        </el-table-column>

        <el-table-column
          label="最近沟通内容"
          width="300"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span style="color: green">{{
              scope.row.firstRecordRemarkStr
            }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" fixed="right" width="50" label="沟通">
          <template slot-scope="scope">
            <el-link
              slot="reference"
              type="primary"
              @click="AddRecordCount(scope.row)"
              >{{ scope.row.recordCount }}</el-link
            >
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-size="page_size"
          layout="total,prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-drawer
      title="跟进记录"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <div>
        <div>
          <div style="margin-left: 10px">
            <el-divider direction="vertical"></el-divider>
            <span style="font-size: 16px; color: #333; line-height: 28px"
              >跟进动态</span
            >

            <span
              style="
                color: #529dfe;
                line-height: 28px;
                float: right;
                margin-right: 20px;
                cursor: pointer;
              "
              @click="OverIntentRecord('0')"
              v-if="updateform.is_over"
              >结束</span
            >
          </div>

          <div
            style="
              border: 1px solid #e5e9f2;
              text-align: center;
              padding: 20px;
              margin: 20px;
              border-radius: 5px;
              line-height: 22px;
              font-size: 14px;
              cursor: pointer;
              color: #909399;
            "
            v-if="flowinput"
            @click="OpenFlowInput"
          >
            <i class="el-icon-edit"></i>
            <span>发布跟进记录</span>
          </div>

          <div class="flowrecord" v-if="flowinput && recordList.length > 0">
            <div>全部记录</div>
            <div
              style="margin-top: 10px"
              v-for="item of recordList"
              :key="item.id"
            >
              <el-card shadow="hover">
                <div style="margin-bottom: 10px">
                  <span style="color: rgb(145, 149, 158); font-size: 14px"
                    >记录人:</span
                  >
                  <span style="margin-left: 10px; font-size: 14px">{{
                    item.link_man_name
                  }}</span>

                  <i
                    style="float: right; cursor: pointer"
                    class="el-icon-delete"
                    @click="adminDeleteAuthSchoolRecord(item)"
                  ></i>

                  <i
                    style="float: right; margin-right: 20px; cursor: pointer"
                    class="el-icon-edit"
                    @click="EditUserRecord(item)"
                  ></i>
                </div>

                <div style="margin-bottom: 10px">
                  <span style="color: rgb(145, 149, 158); font-size: 14px"
                    >记录日期:</span
                  >
                  <span style="margin-left: 10px; font-size: 14px">{{
                    item.created_time
                  }}</span>
                </div>

                <div style="margin-bottom: 10px">
                  <span style="color: rgb(145, 149, 158); font-size: 14px"
                    >记录内容:</span
                  >
                  <span style="margin-left: 10px; font-size: 14px">{{
                    item.remark
                  }}</span>
                </div>

                <div style="margin-bottom: 10px">
                  <span style="color: rgb(145, 149, 158); font-size: 14px"
                    >记录类型:</span
                  >
                  <span style="margin-left: 10px; font-size: 14px">
                    <span v-if="item.record_type == '1'">校区概况</span>
                    <span v-else-if="item.record_type == '2'">新需求</span>
                    <span v-else-if="item.record_type == '3'">反馈问题</span>
                    <span v-else-if="item.record_type == '10'">其他</span>
                  </span>
                </div>
              </el-card>
            </div>

            <div style="margin: 20px; text-align: right">
              <el-pagination
                @current-change="handleCurrentChange1"
                :current-page="page_no1"
                :page-size="page_size1"
                layout="total, prev, pager, next, jumper"
                :total="total1"
              >
              </el-pagination>
            </div>
          </div>

          <div v-if="!flowinput">
            <div
              style="
                margin-left: 20px;
                margin-top: 20px;
                color: #91959e;
                font-size: 14px;
              "
            >
              <span>发布跟进记录</span>
              <i
                class="el-icon-close"
                style="
                  float: right;
                  margin-right: 20px;
                  font-size: 16px;
                  cursor: pointer;
                  font-weight: bold;
                "
                @click="CloseFlowInput"
              ></i>
            </div>

            <div>
              <div style="margin-left: 30px; margin-top: 10px; font-size: 12px">
                记录内容 <span style="color: red">*</span>
              </div>

              <div style="margin: 20px">
                <el-input
                  type="textarea"
                  :rows="4"
                  placeholder="请输入跟进内容"
                  v-model="form_flow.remark"
                >
                </el-input>

                <el-form
                  ref="form"
                  style="margin-top: 20px"
                  label-width="80px"
                  size="mini"
                >
                  <el-form-item label="记录类型" required>
                    <el-select
                      v-model="form_flow.record_type"
                      placeholder="请选择记录类型"
                      style="width: 200px"
                    >
                      <el-option label="校区概况" :value="1"></el-option>
                      <el-option label="新需求" :value="2"></el-option>
                      <el-option label="反馈问题" :value="3"></el-option>
                      <el-option label="其他" :value="10"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item size="small">
                    <el-button
                      type="primary"
                      @click="adminAddOrUpdateAuthSchoolRecord"
                      >发布记录</el-button
                    >
                    <el-button @click="CloseFlowInput">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  adminCreateSysSchoolEffectInfo,
  adminGetSysSchoolEffectTotalInfo,
  adminGetSysSchoolEffectInfoList,
  adminAddOrUpdateAuthSchoolRecord,
  adminGetAuthSchoolRecordList,
  adminDeleteAuthSchoolRecord,
} from "@/api/admin";

export default {
  name: "csm-basic",
  components: {},
  data() {
    return {
      //客户成功中心
      SchoolList: [
        {
          name: "五格演示校区",
          username: "18722160686",
        },
        {
          name: "乐博乐博",
          username: "15522869972",
        },
        {
          name: "瓦力工厂",
          username: "1822222222",
        },
      ],
      myChart: {},

      //实施看板
      schoolEffectionTotalInfo: {},
      x_data: [], //实施看板横坐标
      y_data: [], //实施看板纵坐标
      educational_institution_name: "",
      username: "",
      effect_info_score: null,
      page_no: 1,
      page_size: 20,
      total: 0,
      schoolList: [], //学校列表

      form: {
        educational_institution_name: "",
        username: "",
        is_try: "",
      },

      //沟通记录
      drawer: false,
      direction: "rtl",
      updateform: {
        id: "",
        realname: "",
        sex: "",
        grade: "",
        parent_a: "",
        parent_a_phone_num: "",
        nickname: "",
        school_name: "",
        birthday: "",
        parent_b: "",
        parent_b_phone_num: "",
        state: "",
        leader: "",
        remark: "",
        educational_institution_campus_id: "",
        userImageUrl: "", //责任人头像
        leaderName: "", //责任人姓名
        intended_level: 0,
        status: "", //发布状态
        is_over: false,
      },

      form_flow: {
        remark: "",
        record_type: "",
        next_date: "", //下次跟进
        value: 0, //意向级别
        come_date: "",
        if_come_state: "",
        record_status: "",
        state: 0,
        id: "",
      },

      flowinput: true,
      recordList: [],
      school_id: "", //学校ID

      //跟进记录页码控制
      page_size1: 10,
      page_no1: 1,
      total1: 0,
    };
  },
  computed: {},
  mounted() {
    if (this.$store.getters.adminToken) {
      this.adminGetSysSchoolEffectTotalInfo();
      this.adminGetSysSchoolEffectInfoList();
    }
  },
  methods: {
    //计算实施数据
    adminCreateSysSchoolEffectInfo() {
      adminCreateSysSchoolEffectInfo().then((res) => {
        console.log("计算实施数据");
        console.log(res);
        if (res.is_create) {
          this.$message.success("数据统计完成");
        }
      });
    },

    //实施看板总分数
    adminGetSysSchoolEffectTotalInfo() {
      adminGetSysSchoolEffectTotalInfo().then((res) => {
        console.log("实施看板分数");
        console.log(res);
        this.schoolEffectionTotalInfo = res.schoolEffectionTotalInfo;

        this.x_data = [];
        this.y_data = [];

        for (let k = 0; k < this.schoolEffectionTotalInfo.length; k++) {
          this.x_data.push(
            this.schoolEffectionTotalInfo[k].effect_info_score + "分"
          );
          this.y_data.push(this.schoolEffectionTotalInfo[k].count);
        }

        this.$nextTick(function () {
          this.drawLine();
        });
      });
    },

    //实施数据详情
    adminGetSysSchoolEffectInfoList() {
      adminGetSysSchoolEffectInfoList({
        is_try: this.form.is_try,
        educational_institution_name: this.form.educational_institution_name,
        username: this.form.username,
        effect_info_score: this.effect_info_score,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log("实施数据学校详情");
        console.log(res);
        this.schoolList = res.schoolList;
        this.total = res.total;
      });
    },

    AddRecordCount(row) {
      console.log("当前学校信息");
      console.log(row);
      this.school_id = row.id;
      this.drawer = true;
      this.adminGetAuthSchoolRecordList();
    },

    //意向客户跟进
    CloseFlowInput() {
      console.log("关闭记录");
      this.flowinput = true;
      this.form_flow.record_type = "";
      this.form_flow.remark = "";
    },

    OpenFlowInput() {
      this.flowinput = false;
      this.form_flow.id = "";
    },

    //发布跟进记录
    adminAddOrUpdateAuthSchoolRecord() {
      console.log("提交的参数");
      console.log(this.school_id);
      console.log(this.updateform.record_type);
      console.log(this.updateform.remark);

      if (!this.form_flow.id) {
        adminAddOrUpdateAuthSchoolRecord({
          educational_institution_id: this.school_id,
          record_type: this.form_flow.record_type,
          remark: this.form_flow.remark,
        }).then((res) => {
          console.log("发布校区跟进记录");
          console.log(res);
          if (res.is_created) {
            this.$message.success("记录成功");
            this.adminGetAuthSchoolRecordList();
            this.CloseFlowInput();
          }
        });
      } else {
        adminAddOrUpdateAuthSchoolRecord({
          recordId: this.form_flow.id,
          educational_institution_id: this.school_id,
          record_type: this.form_flow.record_type,
          remark: this.form_flow.remark,
        }).then((res) => {
          console.log("发布校区跟进记录");
          console.log(res);
          if (res.is_update) {
            this.$message.success("记录成功");
            this.adminGetAuthSchoolRecordList();
            this.CloseFlowInput();
          }
        });
      }
    },

    adminGetAuthSchoolRecordList() {
      adminGetAuthSchoolRecordList({
        educational_institution_id: this.school_id,
        start_date: "",
        end_date: "",
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log("学校沟通记录");
        console.log(res);
        this.recordList = res.recordList;
        this.total1 = res.total;
      });
    },

    adminDeleteAuthSchoolRecord(row) {
      this.$confirm("确定删除本条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adminDeleteAuthSchoolRecord({
          recordId: row.id,
        }).then((res) => {
          console.log(res);
          if (res.is_delete) {
            this.$message.success("删除成功");
            this.adminGetAuthSchoolRecordList();
          }
        });
      });
    },

    //编辑跟进记录
    EditUserRecord(item) {
      console.log("编辑跟进记录");
      console.log(item);
      this.form_flow.id = item.id;
      this.form_flow.remark = item.remark;
      this.form_flow.record_type = item.record_type;

      this.flowinput = false;
    },

    handleClose() {
      this.adminGetSysSchoolEffectInfoList();
      this.drawer = false;
    },

    handleCurrentChange(val) {
      this.page_no = val;
      this.adminGetSysSchoolEffectInfoList();
    },

    handleCurrentChange1(val) {
      this.page_no1 = val;
      this.adminGetAuthSchoolRecordList();
    },

    search() {
      this.page_no = 1;
      this.effect_info_score = "";
      this.adminGetSysSchoolEffectInfoList();
    },

    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      this.myChart.setOption({
        title: { text: "" },
        tooltip: {},
        xAxis: {
          data: this.x_data,
        },
        yAxis: {},
        series: [
          {
            name: "校区数",
            type: "bar",
            data: this.y_data,
          },
        ],
      });

      var that = this;

      this.myChart.on("click", function (params) {
        console.log(params.name);
        that.effect_info_score = params.name;
        that.page_no = 1;
        that.adminGetSysSchoolEffectInfoList();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.csm-basic {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 10px;

  .flowrecord {
    height: calc(100vh - 210px);
    margin: 20px;
    overflow-y: scroll;
  }
}
</style>

